var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reservation" },
    [
      _vm.isEdit || _vm.isNew
        ? _c("ValidationObserver", {
            ref: "reservationForm",
            staticClass: "reservation__form",
            attrs: { tag: "form", novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.onSubmitReservation.apply(null, arguments)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var invalid = ref.invalid
                    var errors = ref.errors
                    return [
                      _vm.isNew &&
                      !_vm.isLoggedIn &&
                      (_vm.hasFeature("FEATURE_ACCOUNT") ||
                        _vm.hasFeature("FEATURE_ACCOUNT_LOGGEDIN"))
                        ? _c("section", { staticClass: "reservation__block" }, [
                            _c(
                              "div",
                              { staticClass: "reservation__login" },
                              [
                                _c("div", {
                                  staticClass: "reservation__login-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("reservation.loginText")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("Button", {
                                  attrs: {
                                    level: "tertiary",
                                    type: "button",
                                    text: _vm.$t("reservation.loginButton"),
                                    arrow: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.onLoginClick.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h1", {
                        staticClass: "reservation__title",
                        domProps: { innerHTML: _vm._s(_vm.mainTitle) }
                      }),
                      _vm._v(" "),
                      _vm.reservationResponse.message
                        ? _c("GeneralMessage", {
                            ref: "reservationResponse",
                            attrs: {
                              message: _vm.reservationResponse.message,
                              type: _vm.reservationResponse.type
                            },
                            on: {
                              close: function($event) {
                                _vm.reservationResponse.message = ""
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.restaurantOptions.length
                        ? _c("ValidationProvider", {
                            staticClass: "reservation__block",
                            attrs: {
                              name: "restaurant",
                              rules: "required",
                              tag: "section",
                              customMessages: {
                                required: _vm.$t("forms.errors.fieldEmpty")
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    var invalid = ref.invalid
                                    var validated = ref.validated
                                    var dirty = ref.dirty
                                    return [
                                      _c("h2", {
                                        staticClass: "reservation__subtitle",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "reservation.restaurantTitle"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("FormInputSelect", {
                                        attrs: {
                                          options: _vm.restaurantOptions,
                                          label: _vm.$t(
                                            "reservation.restaurantLabel"
                                          ),
                                          disabled: _vm.isEdit,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.selectedRestaurant,
                                          callback: function($$v) {
                                            _vm.selectedRestaurant = $$v
                                          },
                                          expression: "selectedRestaurant"
                                        }
                                      }),
                                      _vm._v(" "),
                                      invalid && validated
                                        ? _c("span", {
                                            staticClass: "input-error",
                                            domProps: {
                                              innerHTML: _vm._s(errors[0])
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedRestaurant
                                        ? _c("OrderBoxLocation", {
                                            attrs: {
                                              location:
                                                _vm.reservationRestaurant,
                                              "shipping-method": "takeaway",
                                              "no-click": ""
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _vm.initialized
                        ? _c("section", { staticClass: "reservation__block" }, [
                            _c("h2", {
                              staticClass: "reservation__error",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("reservation.errors.noRestaurants")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRestaurant
                        ? _c(
                            "section",
                            { staticClass: "reservation__block" },
                            [
                              _c("h2", {
                                staticClass: "reservation__subtitle",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("reservation.seatsTitle")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("QuantityCounter", {
                                attrs: {
                                  quantity: _vm.selectedSeats,
                                  "base-class": "reservation__seats",
                                  locked: _vm.formLocked,
                                  min: _vm.minSeats,
                                  max: _vm.maxSeats
                                },
                                on: {
                                  sub: function($event) {
                                    return _vm.onDecreaseSeat()
                                  },
                                  add: function($event) {
                                    return _vm.onIncreaseSeat()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRestaurant
                        ? _c("ValidationProvider", {
                            staticClass: "reservation__block",
                            attrs: {
                              name: "date",
                              rules: "required",
                              tag: "section",
                              customMessages: {
                                required: _vm.$t("forms.errors.fieldEmpty")
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    var invalid = ref.invalid
                                    var validated = ref.validated
                                    return [
                                      _c("h2", {
                                        staticClass: "reservation__subtitle",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("reservation.dateTitle")
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("AvailabilityCalendar", {
                                        attrs: {
                                          loading: _vm.monthLoading,
                                          availabilities:
                                            _vm.reservationMonthAvailabilities,
                                          required: ""
                                        },
                                        on: {
                                          "change:month": _vm.onMonthChange
                                        },
                                        model: {
                                          value: _vm.selectedDate,
                                          callback: function($$v) {
                                            _vm.selectedDate = $$v
                                          },
                                          expression: "selectedDate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      invalid && validated
                                        ? _c("span", {
                                            staticClass: "input-error",
                                            domProps: {
                                              innerHTML: _vm._s(errors[0])
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedDate &&
                      _vm.reservationRules &&
                      !_vm.showReservationEvents &&
                      !_vm.reservationOnlyByPhone
                        ? _c("section", { staticClass: "reservation__block" }, [
                            _c("div", {
                              staticClass: "reservation__text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.fwgcmstext(
                                    _vm.reservationRules
                                  )
                                )
                              }
                            })
                          ])
                        : _vm.selectedDate &&
                          _vm.showReservationEvents &&
                          !_vm.reservationOnlyByPhone
                        ? _vm._l(_vm.reservationEvents, function(event) {
                            return _c(
                              "section",
                              {
                                staticClass:
                                  "reservation__block reservation__block--image"
                              },
                              [
                                event.image
                                  ? _c(
                                      "div",
                                      { staticClass: "reservation__image" },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "reservation__image-element",
                                          attrs: {
                                            src: event.image.src,
                                            srcset: event.image.srcset
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "reservation__text",
                                  domProps: { innerHTML: _vm._s(event.text) }
                                })
                              ]
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.reservationRooms.length > 1 &&
                      !_vm.reservationOnlyByPhone
                        ? _c("ValidationProvider", {
                            staticClass: "reservation__block",
                            attrs: {
                              name: "room",
                              rules: "required",
                              tag: "section",
                              customMessages: {
                                required: _vm.$t("forms.errors.fieldEmpty")
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    var invalid = ref.invalid
                                    var validated = ref.validated
                                    var dirty = ref.dirty
                                    return [
                                      _c("h2", {
                                        staticClass: "reservation__subtitle",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("reservation.roomTitle")
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("FormInputSelect", {
                                        attrs: {
                                          options: _vm.roomOptions,
                                          label: _vm.$t(
                                            "reservation.roomLabel"
                                          ),
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.selectedRoom,
                                          callback: function($$v) {
                                            _vm.selectedRoom = $$v
                                          },
                                          expression: "selectedRoom"
                                        }
                                      }),
                                      _vm._v(" "),
                                      invalid && validated
                                        ? _c("span", {
                                            staticClass: "input-error",
                                            domProps: {
                                              innerHTML: _vm._s(errors[0])
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTimeSelect
                        ? [
                            _c("ValidationProvider", {
                              staticClass: "reservation__block",
                              attrs: {
                                name: "time",
                                rules: "required",
                                tag: "section",
                                customMessages: {
                                  required: _vm.$t("forms.errors.fieldEmpty")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      var invalid = ref.invalid
                                      var validated = ref.validated
                                      return [
                                        _c("h2", {
                                          staticClass: "reservation__subtitle",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("reservation.timeTitle")
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("TimePicker", {
                                          attrs: {
                                            times: _vm.timeOptions,
                                            label: _vm.$t("forms.labels.time")
                                          },
                                          model: {
                                            value: _vm.selectedTime,
                                            callback: function($$v) {
                                              _vm.selectedTime = $$v
                                            },
                                            expression: "selectedTime"
                                          }
                                        }),
                                        _vm._v(" "),
                                        invalid && validated
                                          ? _c("span", {
                                              staticClass: "input-error",
                                              domProps: {
                                                innerHTML: _vm._s(errors[0])
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showAsyncMessage
                                          ? _c("GeneralMessage", {
                                              attrs: {
                                                type: "warning",
                                                message:
                                                  "* " +
                                                  _vm.$t(
                                                    "reservation.asyncMessage"
                                                  ),
                                                stick: ""
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _vm.reservationVegiSeats
                              ? _c(
                                  "section",
                                  { staticClass: "reservation__block" },
                                  [
                                    _c("h2", {
                                      staticClass: "reservation__subtitle",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("reservation.vegiSeats.title")
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "reservation__text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("reservation.vegiSeats.text")
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "addVegiSeats",
                                        rules: "required",
                                        tag: "div",
                                        customMessages: {
                                          required: _vm.$t(
                                            "reservation.vegiSeats.error"
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var errors = ref.errors
                                              var invalid = ref.invalid
                                              var validated = ref.validated
                                              var dirty = ref.dirty
                                              return [
                                                _c("FormInputRadio", {
                                                  attrs: {
                                                    name: "addVegiSeats",
                                                    options: [
                                                      {
                                                        value: "0",
                                                        label: _vm.$t(
                                                          "reservation.vegiSeats.no"
                                                        )
                                                      },
                                                      {
                                                        value: "1",
                                                        label: _vm.$t(
                                                          "reservation.vegiSeats.yes"
                                                        )
                                                      }
                                                    ],
                                                    disabled: _vm.formLocked,
                                                    vertical: "",
                                                    inline: "",
                                                    required: ""
                                                  },
                                                  model: {
                                                    value: _vm.addVegiSeats,
                                                    callback: function($$v) {
                                                      _vm.addVegiSeats = $$v
                                                    },
                                                    expression: "addVegiSeats"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                invalid && validated
                                                  ? _c("span", {
                                                      staticClass:
                                                        "input-error",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          errors[0]
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _vm._v(" "),
                                    _vm.form.vegiSeats
                                      ? [
                                          _c("ValidationProvider", {
                                            attrs: {
                                              name: "vegiSeats",
                                              rules: "min_value:1",
                                              tag: "div",
                                              customMessages: {
                                                min_value: _vm.$t(
                                                  "reservation.vegiSeats.errorQuantity"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    var invalid = ref.invalid
                                                    var validated =
                                                      ref.validated
                                                    var dirty = ref.dirty
                                                    return [
                                                      _c("div", {
                                                        staticClass:
                                                          "reservation__text",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.$t(
                                                              "reservation.vegiSeats.quantityLabel"
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        attrs: {
                                                          type: "hidden"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.form.vegiSeats
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("QuantityCounter", {
                                                        attrs: {
                                                          quantity:
                                                            _vm.form.vegiSeats,
                                                          "base-class":
                                                            "reservation__seats",
                                                          locked:
                                                            _vm.formLocked,
                                                          min: 1,
                                                          max: _vm.selectedSeats
                                                        },
                                                        on: {
                                                          sub: function(
                                                            $event
                                                          ) {
                                                            return _vm.onDecreaseVegiSeat()
                                                          },
                                                          add: function(
                                                            $event
                                                          ) {
                                                            return _vm.onIncreaseVegiSeat()
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      invalid && validated
                                                        ? _c("div", {
                                                            staticClass:
                                                              "input-error input-error--margin",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                errors[0]
                                                              )
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.reservationChoicesWithoutSpecials.length
                              ? _c(
                                  "section",
                                  { staticClass: "reservation__block" },
                                  _vm._l(
                                    _vm.reservationChoicesWithoutSpecials,
                                    function(choice, index) {
                                      return _c("ValidationProvider", {
                                        key: "choice-" + index,
                                        attrs: {
                                          rules: choice.info.required
                                            ? {
                                                required: { allowFalse: false }
                                              }
                                            : "",
                                          name: "choice-" + index,
                                          tag: "div",
                                          customMessages: {
                                            required: _vm.$t(
                                              "forms.errors.fieldEmpty"
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var invalid = ref.invalid
                                                var errors = ref.errors
                                                var validated = ref.validated
                                                return [
                                                  choice.info.label
                                                    ? _c("div", {
                                                        staticClass:
                                                          "reservation__lead",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            choice.info.label
                                                          )
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  choice.info.infotext
                                                    ? _c("div", {
                                                        staticClass:
                                                          "reservation__text",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            choice.info.infotext
                                                          )
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  choice.info.options.length > 1
                                                    ? _c("FormInputRadio", {
                                                        attrs: {
                                                          name:
                                                            "choice-" + index,
                                                          options: choice.info.options.map(
                                                            function(c) {
                                                              return {
                                                                label: c.label,
                                                                value: c.label
                                                              }
                                                            }
                                                          ),
                                                          value:
                                                            _vm.form.choices[
                                                              index
                                                            ],
                                                          disabled:
                                                            _vm.formLocked,
                                                          required:
                                                            choice.info
                                                              .required,
                                                          vertical: ""
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.onChoicesChange(
                                                              $event,
                                                              index
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _c("FormInputCheckbox", {
                                                        attrs: {
                                                          name:
                                                            "choice-" + index,
                                                          checked: !!_vm.form
                                                            .choices[index],
                                                          disabled:
                                                            _vm.formLocked,
                                                          required:
                                                            choice.info
                                                              .required,
                                                          label:
                                                            choice.info
                                                              .options[0].label
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.onChoicesChange(
                                                              $event
                                                                ? choice.info
                                                                    .options[0]
                                                                    .label
                                                                : null,
                                                              index,
                                                              choice
                                                            )
                                                          }
                                                        }
                                                      }),
                                                  _vm._v(" "),
                                                  invalid && validated
                                                    ? _c("span", {
                                                        staticClass:
                                                          "input-error",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            errors[0]
                                                          )
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.indiningAvailable
                              ? _c(
                                  "section",
                                  { staticClass: "reservation__block" },
                                  [
                                    _c("h2", {
                                      staticClass: "reservation__subtitle",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "reservation.indining.optionTitle"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "reservation__text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "reservation.indining.optionText"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "FormInputCheckbox",
                                      {
                                        attrs: {
                                          name: "indining",
                                          disabled: _vm.formLocked
                                        },
                                        model: {
                                          value: _vm.form.indining,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "indining", $$v)
                                          },
                                          expression: "form.indining"
                                        }
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "reservation.indining.optionLabel"
                                              )
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.formReady
                              ? _c(
                                  "section",
                                  { staticClass: "reservation__block" },
                                  [
                                    _c("h2", {
                                      staticClass: "reservation__subtitle",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.detailsTitle)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.isNew
                                      ? _c("ValidationProvider", {
                                          attrs: {
                                            name: "firstname",
                                            rules: "required",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.firstname"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.firstname"
                                                        ),
                                                        name: "firstname",
                                                        error:
                                                          errors.length > 0,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.firstName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "firstName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.firstName"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isNew
                                      ? _c("ValidationProvider", {
                                          attrs: {
                                            name: "lastname",
                                            rules: "required",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.lastname"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.lastname"
                                                        ),
                                                        name: "lastname",
                                                        error:
                                                          errors.length > 0,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.lastName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "lastName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.lastName"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isNew
                                      ? _c("ValidationProvider", {
                                          attrs: {
                                            name: "phone",
                                            rules: "required|phone",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              ),
                                              phone: _vm.$t(
                                                "forms.errors.phone"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "tel",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.phone"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.phone"
                                                        ),
                                                        name: "phone",
                                                        error:
                                                          errors.length > 0,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.phoneNumber,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "phoneNumber",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.phoneNumber"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "additional-info",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "reservation.phoneHint"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isNew
                                      ? _c("ValidationProvider", {
                                          attrs: {
                                            name: "email",
                                            rules: "required|email",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              ),
                                              email: _vm.$t(
                                                "forms.errors.emailInvalid"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "email",
                                                        name: "email",
                                                        autocomplete: "email",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.email"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.email"
                                                        ),
                                                        error:
                                                          errors.length > 0,
                                                        readonly: !!_vm.isLoggedIn,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value: _vm.form.email,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "form.email"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "additional-info",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "reservation.emailHint"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("FormInputTextarea", {
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "forms.labels.notes"
                                        ),
                                        label: _vm.$t("forms.labels.notes")
                                      },
                                      model: {
                                        value: _vm.form.notes,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "notes", $$v)
                                        },
                                        expression: "form.notes"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: {
                                          required: { allowFalse: false }
                                        },
                                        name: "acceptTerms",
                                        tag: "div",
                                        customMessages: {
                                          required: _vm.$t(
                                            "reservation.errorTerms"
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var invalid = ref.invalid
                                              var errors = ref.errors
                                              var validated = ref.validated
                                              return [
                                                _c(
                                                  "FormInputCheckbox",
                                                  {
                                                    attrs: {
                                                      name: "terms",
                                                      value: "acceptTerms",
                                                      required: "",
                                                      immediate: "",
                                                      block: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.acceptTerms,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "acceptTerms",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.acceptTerms"
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "reservation.termsLabel"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                invalid && validated
                                                  ? _c("span", {
                                                      staticClass:
                                                        "input-error",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          errors[0]
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: {
                                          required: { allowFalse: false }
                                        },
                                        name: "acceptPrivacy",
                                        tag: "div",
                                        customMessages: {
                                          required: _vm.$t(
                                            "reservation.errorPrivacy"
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var invalid = ref.invalid
                                              var errors = ref.errors
                                              var validated = ref.validated
                                              return [
                                                _c(
                                                  "FormInputCheckbox",
                                                  {
                                                    attrs: {
                                                      name: "terms",
                                                      value: "acceptPrivacy",
                                                      required: "",
                                                      immediate: "",
                                                      block: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.acceptPrivacy,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "acceptPrivacy",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.acceptPrivacy"
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "reservation.privacyLabel"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                invalid && validated
                                                  ? _c("span", {
                                                      staticClass:
                                                        "input-error",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          errors[0]
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("Button", {
                                      attrs: {
                                        type: "submit",
                                        level: "primary",
                                        text: _vm.$t(
                                          "reservation.submitButton"
                                        ),
                                        disabled:
                                          _vm.formLocked || !_vm.formReady
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isEdit
                              ? _c(
                                  "section",
                                  { staticClass: "reservation__block" },
                                  [
                                    _c("Button", {
                                      attrs: {
                                        type: "button",
                                        level: "tertiary",
                                        text: _vm.$t(
                                          "reservation.cancelReservation"
                                        ),
                                        disabled:
                                          _vm.formLocked || !_vm.formReady,
                                        arrow: ""
                                      },
                                      on: { click: _vm.onReservationCancel }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm.reservationOnlyByPhone
                        ? _c("section", { staticClass: "reservation__block" }, [
                            _c("h2", {
                              staticClass: "reservation__error",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("reservation.errors.pastCutoff", {
                                    phone:
                                      _vm.reservationRestaurant.phoneNumber,
                                    phoneRaw: _vm.reservationRestaurant.phoneNumber.replace(
                                      /(\(\d\))|[\s-_]/g,
                                      ""
                                    )
                                  })
                                )
                              }
                            })
                          ])
                        : _vm.reservationAvailabilitiesLoaded &&
                          !_vm.reservationLoading &&
                          _vm.reservationDate &&
                          (!_vm.timeOptions.length || _vm.timesDisabled) &&
                          (!_vm.reservationRooms.length ||
                            (_vm.reservationRooms.length &&
                              _vm.reservationRoom))
                        ? _c(
                            "section",
                            { staticClass: "reservation__block" },
                            [
                              _vm.timesMaxSeats &&
                              _vm.timesMaxSeats < _vm.selectedSeats
                                ? _c("i18n", {
                                    staticClass: "reservation__error",
                                    attrs: {
                                      path: "reservation.errors.notEnoughSeats",
                                      tag: "h2"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "max",
                                          fn: function() {
                                            return [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(_vm.timesMaxSeats) +
                                                  "\n          "
                                              )
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "link",
                                          fn: function() {
                                            return [
                                              _vm.reservationRestaurant.phoneNumber.includes(
                                                "@"
                                              )
                                                ? _c("a", {
                                                    attrs: {
                                                      href:
                                                        "mailto:" +
                                                        _vm
                                                          .reservationRestaurant
                                                          .phoneNumber
                                                    },
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm
                                                          .reservationRestaurant
                                                          .phoneNumber
                                                      )
                                                    }
                                                  })
                                                : _c("a", {
                                                    attrs: {
                                                      href:
                                                        "tel:" +
                                                        _vm.reservationRestaurant.phoneNumber.replace(
                                                          /(\(\d\))|[\s-_]/g,
                                                          ""
                                                        )
                                                    },
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm
                                                          .reservationRestaurant
                                                          .phoneNumber
                                                      )
                                                    }
                                                  })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      1773483298
                                    )
                                  })
                                : _c("h2", {
                                    staticClass: "reservation__error",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("reservation.errors.noDates")
                                      )
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              566374768
            )
          })
        : _vm.isComplete || _vm.isCanceled || _vm.isExpired
        ? _c(
            "div",
            [
              _c("h1", {
                staticClass: "reservation__title",
                domProps: { innerHTML: _vm._s(_vm.completedTitle) }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "reservation__text",
                domProps: { innerHTML: _vm._s(_vm.completedText) }
              }),
              _vm._v(" "),
              _vm.reservationDetails && _vm.reservationDetails.pending
                ? _c("GeneralMessage", {
                    attrs: {
                      type: "warning",
                      message: _vm.$t("reservation.complete.pending"),
                      stick: ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "reservation__block" },
                [
                  _c("h2", {
                    staticClass: "reservation__subtitle",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("reservation.complete.reservationTitle")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("ul", { staticClass: "reservation__details" }, [
                    _c("li", { staticClass: "reservation__detail" }, [
                      _c("strong", {
                        staticClass: "reservation__detail-label",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("reservation.complete.detailsName")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "reservation__detail-value",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.form.firstName + " " + _vm.form.lastName
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "reservation__detail" }, [
                      _c("strong", {
                        staticClass: "reservation__detail-label",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("reservation.complete.detailsRestaurant")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "reservation__detail-value",
                        domProps: {
                          innerHTML: _vm._s(_vm.reservationRestaurantName)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "reservation__detail" }, [
                      _c("strong", {
                        staticClass: "reservation__detail-label",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("reservation.complete.detailsPeople")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "reservation__detail-value",
                        domProps: { innerHTML: _vm._s(_vm.reservationSeats) }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.reservationDetails && _vm.reservationDetails.roomName
                      ? _c("li", { staticClass: "reservation__detail" }, [
                          _c("strong", {
                            staticClass: "reservation__detail-label",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reservation.complete.detailsRoom")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "reservation__detail-value",
                            domProps: {
                              innerHTML: _vm._s(_vm.reservationDetails.roomName)
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "reservation__detail",
                        class: {
                          "reservation__detail--canceled": _vm.isCanceled
                        }
                      },
                      [
                        _c("strong", {
                          staticClass: "reservation__detail-label",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("reservation.complete.detailsDate")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "reservation__detail-value",
                          domProps: { innerHTML: _vm._s(_vm.reservationDate) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "reservation__detail",
                        class: {
                          "reservation__detail--canceled": _vm.isCanceled
                        }
                      },
                      [
                        _c("strong", {
                          staticClass: "reservation__detail-label",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("reservation.complete.detailsTime")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "reservation__detail-value",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.reservationTimeEnd
                                ? _vm.reservationTime +
                                    " - " +
                                    _vm.reservationTimeEnd
                                : _vm.reservationTime
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isCanceled &&
                    !_vm.isExpired &&
                    _vm.reservationDetails &&
                    _vm.reservationDetails.editable
                      ? _c(
                          "li",
                          {
                            staticClass:
                              "reservation__detail reservation__detail--buttons"
                          },
                          [
                            _c("Button", {
                              staticClass: "account__reservation-button",
                              attrs: {
                                type: "button",
                                title: _vm.$t(
                                  "account.reservations.cancelButton"
                                ),
                                level: "secondary",
                                icon: "trash",
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onReservationCancel()
                                }
                              }
                            }),
                            _vm._v(" "),
                            !_vm.isIndining
                              ? _c("Button", {
                                  staticClass: "account__reservation-button",
                                  attrs: {
                                    type: "button",
                                    title: _vm.$t(
                                      "account.reservations.editButton"
                                    ),
                                    level: "primary",
                                    icon: "edit",
                                    small: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onReservationEdit()
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.reservationDetails.emailHash256
                    ? _c("input", {
                        attrs: { type: "hidden", name: "email-hash" },
                        domProps: { value: _vm.reservationDetails.emailHash256 }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isCanceled && !_vm.isExpired && _vm.reservationCalendar
                    ? _c("Button", {
                        attrs: {
                          type: "button",
                          level: "tertiary",
                          text: _vm.$t("reservation.calendarButton"),
                          disabled: _vm.loading,
                          href: _vm.reservationCalendarUrl,
                          icon: "date",
                          arrow: "",
                          download: _vm.$t("reservation.calendarFile", {
                            date: _vm.reservationDate
                          })
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isCanceled &&
              !_vm.isExpired &&
              (_vm.indiningAvailable ||
                (_vm.reservationDetails &&
                  _vm.reservationDetails.indiningAvailable))
                ? [
                    _vm.indiningResponse.message
                      ? _c("GeneralMessage", {
                          attrs: {
                            message: _vm.indiningResponse.message,
                            type: _vm.indiningResponse.type
                          },
                          on: {
                            close: function($event) {
                              _vm.indiningResponse.message = ""
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.teaserImage && _vm.teaserImage.src
                      ? _c(
                          "div",
                          {
                            staticClass: "reservation__teaser",
                            on: { click: _vm.onIndiningOrder }
                          },
                          [
                            _c(
                              "figure",
                              { staticClass: "reservation__teaser-image" },
                              [
                                _c("img", {
                                  staticClass:
                                    "reservation__teaser-image-element",
                                  attrs: {
                                    src: _vm.teaserImage.src,
                                    srcset: _vm.teaserImage.srcset,
                                    alt: "teaser-background"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "reservation__teaser-content" },
                              [
                                _c("h3", {
                                  staticClass: "reservation__teaser-title",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "reservation.complete.indiningTitle"
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "reservation__teaser-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "reservation.complete.indiningText"
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("Button", {
                                  staticClass: "reservation__teaser-button",
                                  attrs: {
                                    level: "tertiary",
                                    text: _vm.$t(
                                      "reservation.complete.indiningButton"
                                    ),
                                    arrow: "",
                                    disabled: _vm.loading
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _c(
                          "section",
                          {
                            staticClass: "reservation__block",
                            on: { click: _vm.onIndiningOrder }
                          },
                          [
                            _c("h3", {
                              staticClass: "reservation__subtitle",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("reservation.complete.indiningTitle")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "reservation__text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("reservation.complete.indiningText")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("Button", {
                              attrs: {
                                level: "tertiary",
                                text: _vm.$t(
                                  "reservation.complete.indiningButton"
                                ),
                                arrow: "",
                                disabled: _vm.loading
                              }
                            })
                          ],
                          1
                        )
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.isIndining || _vm.isCanceled || _vm.isExpired
                ? _c(
                    "section",
                    { staticClass: "reservation__block" },
                    [
                      _c("Button", {
                        attrs: {
                          type: "button",
                          level: "secondary",
                          text: _vm.$t("reservation.newReservation"),
                          disabled: _vm.loading
                        },
                        on: { click: _vm.onNewReservation }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }